import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { login } from "../lib/api";
import { Loader2, Lock, AlertCircle, Zap } from "lucide-react";

export default function Login({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      onLoggedIn();
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 bg-[#1A2340] flex items-center justify-center sharp">
            <Zap size={18} className="text-[#F5C800] fill-[#F5C800]" strokeWidth={2.5} />
          </div>
          <div>
            <div className="eyebrow text-[#64748B] leading-none mb-0.5">Attomfit</div>
            <div className="text-[15px] font-bold text-[#1A2340] leading-none">Pricing Engine</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="border border-[#E2E8F0] bg-white sharp p-6 space-y-4">
          <div className="flex items-center gap-2 mb-2">
            <Lock size={14} className="text-[#64748B]" />
            <span className="eyebrow text-[#64748B]">Sign In</span>
          </div>

          <div>
            <Label className="eyebrow text-[#64748B]">Username</Label>
            <Input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-2 rounded-sm border-[#E2E8F0] focus-visible:ring-[#F5C800]"
              data-testid="login-username-input"
              autoFocus
              required
            />
          </div>

          <div>
            <Label className="eyebrow text-[#64748B]">Password</Label>
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 rounded-sm border-[#E2E8F0] focus-visible:ring-[#F5C800]"
              data-testid="login-password-input"
              required
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 border border-[#E11D48]/30 bg-[#E11D48]/5 text-[#E11D48] text-[13px]">
              <AlertCircle size={14} /> {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={submitting}
            className="w-full rounded-sm h-10 bg-[#1A2340] hover:bg-[#253060] text-white font-bold gap-2 disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {submitting ? (
              <>
                <Loader2 size={15} className="animate-spin" /> Signing in…
              </>
            ) : (
              "Sign In"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
}
